import { createFileRoute } from '@tanstack/react-router'

import { CouponsPage } from '@/pages/coupons/coupons-page'

export const Route = createFileRoute('/_private/coupons')({
  component: CouponsPage,
})
